import { useState } from "react";
import { faqs } from "@/mocks/topics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于内容来源、榜单算法和投稿方式，这里集中回答大家最常问的几个问题。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 lg:max-w-4xl">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <i
                      className={`${
                        open ? "ri-subtract-line" : "ri-add-line"
                      } h-5 w-5 shrink-0 flex items-center justify-center text-primary-600`}
                    ></i>
                  </button>
                </h3>
                {open ? (
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}